import { Controller } from "stimulus"

// Intercepts the schedule-attempt form submit when other inspections in the
// same permit family are awaiting scheduling, and offers to schedule them in
// bulk for the same date, time, and inspector. The related-inspection
// checkboxes are rendered disabled so nothing extra is submitted unless the
// modal is shown; declining unchecks them all before submitting.
export default class extends Controller {
    static targets = ["modal", "checkbox"]

    intercept(event) {
        if (this.confirmed) return
        if (event.defaultPrevented) return
        if (!this.hasModalTarget) return
        if (this.checkboxTargets.length === 0) return
        if (this.submitsElsewhere(event)) return
        if (!this.scheduleDatePresent()) return

        event.preventDefault()
        this.submitter = event.submitter
        this.checkboxTargets.forEach((checkbox) => { checkbox.disabled = false })
        this.modalTarget.classList.remove("hidden")
    }

    confirm(event) {
        event.preventDefault()
        this.submitForm()
    }

    decline(event) {
        event.preventDefault()
        this.checkboxTargets.forEach((checkbox) => { checkbox.checked = false })
        this.submitForm()
    }

    close(event) {
        event.preventDefault()
        this.checkboxTargets.forEach((checkbox) => { checkbox.disabled = true })
        this.modalTarget.classList.add("hidden")
    }

    // Re-submits with the originally intercepted submitter so the browser
    // does not fall back to the form's default submit button, which on the
    // edit page may be an earlier button with a formaction.
    submitForm() {
        this.confirmed = true
        this.modalTarget.classList.add("hidden")
        const submitter = this.submitter && this.submitter.isConnected ? this.submitter : null
        if (typeof this.element.requestSubmit === "function") {
            this.element.requestSubmit(submitter)
        } else if (submitter) {
            submitter.click()
        } else {
            this.element.submit()
        }
    }

    // Buttons like "Reschedule" / "Cancel Attempt" post to a different URL via
    // formaction; bulk scheduling only applies to the plain save/schedule submit.
    submitsElsewhere(event) {
        return Boolean(event.submitter && event.submitter.getAttribute("formaction"))
    }

    scheduleDatePresent() {
        const dateField = this.element.querySelector("input[name$='[scheduled_for]']")
        return Boolean(dateField && dateField.value)
    }
}
